import React, { useCallback, useMemo } from 'react';
import FormMultiSelect from '../FormMultiSelect/FormMultiSelect';
import { PORTAL_ROLE_OPTIONS } from '../../../constants/portalRoles';
import { ALL_PORTAL_ROLES } from '../../../utils/permissions';
import type { PortalRole } from '../../../types/portalUser';

interface PortalRoleSelectProps {
  id?: string;
  label?: string;
  error?: string;
  required?: boolean;
  values: PortalRole[];
  onChange: (values: PortalRole[]) => void;
  disabled?: boolean;
  containerClassName?: string;
  placeholder?: string;
}

const isPortalRole = (value: string): value is PortalRole =>
  ALL_PORTAL_ROLES.includes(value as PortalRole);

const PortalRoleSelect: React.FC<PortalRoleSelectProps> = ({
  id = 'portal-role-select',
  label = 'Perfis',
  error,
  required = false,
  values,
  onChange,
  disabled = false,
  containerClassName,
  placeholder = 'Selecione os perfis',
}) => {
  const selectedValues = useMemo(
    () => (values ?? []).filter(isPortalRole),
    [values],
  );

  const handleChange = useCallback((nextValues: string[]) => {
    onChange(nextValues.filter(isPortalRole));
  }, [onChange]);

  return (
    <FormMultiSelect
      id={id}
      label={label}
      error={error}
      required={required}
      values={selectedValues}
      onChange={handleChange}
      options={PORTAL_ROLE_OPTIONS}
      placeholder={placeholder}
      searchPlaceholder="Pesquisar"
      disabled={disabled}
      containerClassName={containerClassName}
      noResultsText="Nenhum perfil encontrado"
      clearButtonLabel="Limpar perfis"
    />
  );
};

export default PortalRoleSelect;
